module.exports = __webpack_public_path__ + "img/avatar-img-icon.dc779bed.svg";